"use client";

import { useEffect, useState } from "react";
import { cardsOpen } from "@/lib/cards";

/**
 * Whether cards can still be ordered, decided in the browser. The pages are edge-cached and render
 * as open; from Nov 30 23:59 ET this flips to false right after mount, and on a page left open across
 * the deadline within a minute.
 */
export function useCardsOpen(): boolean {
  const [open, setOpen] = useState(true);
  useEffect(() => {
    const check = () => setOpen(cardsOpen());
    check();
    const id = setInterval(check, 60_000);
    return () => clearInterval(id);
  }, []);
  return open;
}
